module.exports = __webpack_public_path__ + "media/images/cart/cart_btn04-bbfbc146d5865da928829cbb05fcff02.gif";